import React from 'react';
import { SearchX } from 'lucide-react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const {
    listingsAreLoaded,
    totalItems,
    location,
    resetAll,
    showCreateListingsLink,
    keywords,
    topCategories = [],
  } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  if (!hasNoResult) return null;

  return (
    <div className={css.root}>
      <div className={css.iconWrap}>
        <SearchX className={css.icon} size={40} strokeWidth={1.2} />
      </div>

      <h2 className={css.title}>
        {keywords ? (
          <FormattedMessage
            id="SearchPage.noResultsTitleWithKeyword"
            values={{ keyword: keywords }}
          />
        ) : (
          <FormattedMessage id="SearchPage.noResultsTitle" />
        )}
      </h2>

      <p className={css.subtitle}>
        Try broadening your search, checking the spelling, or browsing a different category above.
      </p>

      {hasSearchParams ? (
        <button className={css.resetButton} onClick={e => resetAll(e)} type="button">
          <FormattedMessage id="SearchPage.resetAllFilters" />
        </button>
      ) : null}

      {showCreateListingsLink ? (
        <NamedLink className={css.sellCta} name="NewListingPage">
          <FormattedMessage id="SearchPage.noResultsSellYourOwn" />
        </NamedLink>
      ) : null}
    </div>
  );
};

export default NoSearchResultsMaybe;
